import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import React, { memo, useEffect } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { getNonHeroBloksFromBody } from '../../utils/getNonHeroBloksFromBody/getNonHeroBloksFromBody.util';

interface EmbeddedQuoteFormPageBlok extends Blok {
  body?: Blok[] | null;
  show_share_page_bar?: boolean;
  show_contact_bar: boolean;
  show_chat?: string;
  structured_data: Blok[];
  lead_source_reference?: string;
}

interface EmbeddedQuoteFormPageProps {
  blok: EmbeddedQuoteFormPageBlok;
}

const EmbeddedQuoteFormPage: React.FC<EmbeddedQuoteFormPageProps> = ({
  blok,
}) => {
  const nonHeroBloks: Blok[] = getNonHeroBloksFromBody(blok.body || []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('embed') === 'true') {
      sessionStorage.setItem('quote-embed', 'true');
    }
  }, []);

  return (
    <div className="flex flex-col h-screen justify-between">
      <main className="mb-auto" {...storyblokEditable(blok)}>
        {nonHeroBloks.map((nonHeroBlok: Blok) => (
          <StoryblokComponent blok={nonHeroBlok} key={nonHeroBlok._uid} />
        ))}
      </main>
    </div>
  );
};

export default memo(EmbeddedQuoteFormPage);
